import {
    Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'
import packingApis from '../../../views/components/packingnew/packingapis.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import printpackdata from './printpackdata'
import moment from 'moment'
import Vue from 'vue';
import apiUrl from '../../../constants';
import axios from 'axios';

export default {
    name: 'Packing',
    components: {
        Loader,
        Multiselect,
        printpackdata
    },
    data: function () {
        return {
            isLoading: false,
            isLoadingFeild: false,
            css1: true,
            css2: false,
            css3: false,
            showButtonManualPacking: false,
            systemLoginCheck: false,
            showBoxInputs: false,
            showBoxDetails: false,
            showProductQcDetails: false,
            isProductReject: false,
            allowPackingComplete: false,
            rejectReasons: [],
            showInvoiceAndLabels: true,
            options: [],
            token: '',
            showQCAndPackingSection: true,
            showPackingCompleteButton: false,
            showPackdata: false,
            salesChannelList: [],
            showSplitBoxData: false,
            sourceBoxData: [],
            showSplitButton: false,
            finalObject: {
                warehouseId: '',
                boxId: '',
                boxWeight: 0,
                clientName: '',
                salesChannel: '',
                orderId: '',
                totalSkus: '',
                orderShiByDate: '',
                shipmentId: '',
                productId: '',
                boxStatus: '',
                orderStatus: '',
                clientId: '',
                scanproductData: '',
                rejectReasons: '',
                userEmail: '',
                salesChannelList: [],
                courierName: '',
                awbNo: '',
                showInvoiceButton: false,
                showLabelButton: false,
                normalOrder: false,
                isRubicon: false,
                isWmall: false,
                isUnicommerce: false,
                isMultiseller: false,
                isNimbus: false,
                isincreff:false,
                cancelProductDetails: [],
                orderType: '',
                sellerName: '',
                totalOrderQty: '',
                userId: '',
                shippingLabel: '',
                invoiceLabel: '',
                shippingCode: '',
                orderTypeInput: '',
                shipmentStatus: '',
                merchantName: '',
                xbEcomFlag: false,
                xbEcomAwbNo: '',
                xbEcomCourierCompany: '',
                orderSelfshipped: '',
                productQty: '',
                showQtyInput: false,
                qcQtyPending: '',
                btoborder: '',
                b2b_qc_done: '',
                shippingCourierCompany: null,
                shippingProviderFinal: null,
                issplited:false,
                isdestinationBox:false
            },
            packingbox1:true,
            packingbox:false,
            sugestboxid:'',
            barcodesugestion:'',
            overidereason:'',
            otherreason:'',
            boxchange:false,
            otherreason1:false,
            listPackingBoxData:[],
            packingboxid : '',
            packingboxname:'',
            suggestedpackbox:'',
            packboxchangereason:'',
            packedbox:false,
            productDetails:false,
            productDetail:[],
            finalBoxData:[],
            showSplitBoxPacking:false,
            showBoxSuggestionSplit:false,
            isSuggestionPresent:false,
            isBoxValid:false,
            splitShimentEnable:false,
            issingleQty:false,
            invoiceLabelcall:0,
            hideInvoiceLabel:false,
            hideproceedWithOutSplit:false,
            hideCourierAwbDetails:false,
            hidesplitBoxbtn:false,
            initiatecall : 0 ,
            issuggestionEnabled:false,
            counterFornullvalue:0,
            invoiceFailureReason : '',

            //Cross Dock Packing Data / cd packing
            cdshowOtherCourierNameField: false,
            cdQcDone: false,
            cdResponseProductDetails: '',
            cdShippingDetails: false,
            cdFieldsDisabled: false,
            cdShowOtherReasonField: false,
            cdBoxDifferentThanReccomendation: false,
            cdLoader: false,
            cdDetails: false,
            cdShowWarehouse: false,
            cdPackingDetails: false,
            cdOutQcDetails: false,
            cdValidateProductResult: '',
			cdClientList: '',
            cdWarehouseList: '',
            cdClient: '',
            cdWarehouse: '',
            cdEanCode: '',
            cdOrderID: '',
            cdOrderType: '',
            cdShipByDate: '',
            cdOrderQuantity: '',
            cdSalesChannel: '',
            cdOutQcDetName: '',
            cdOutQcDetColor: '',
            cdPackingDetRecommBoxType: '',
            cdPackingDetConfirmBoxType: '',
            cdPackingDetSelectedBoxType: '',
            cdShowDiffPackBoxReason: false,
            cdPackingDetReason: '',
            cdPackingDetBoxWeight: 0,
            cdCourierName: '',
            cdAwbNo: '',
            couriercompanyerr: '',
            awbNoerr: ''
            }
    },

    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
        var plaintext = bytes.toString(CryptoJS.enc.Utf8)
        var userdetail = JSON.parse(plaintext)
        var userToken = window.localStorage.getItem('userToken')
        this.token = userToken.replace(/"/g, '')
        this.user_type = userdetail.utype
        this.finalObject.userEmail = userdetail.email
        this.finalObject.userId = userdetail.userid
        this.userid = userdetail.userid
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        if (localStorage.getItem("selectedWarehouse")=="undefined")
        {
            this.$alertify.error(this.$t('common.warehouseError'))
        }
        if (localStorage.getItem("selectedClient")=="undefined")
        {
            this.$alertify.error(this.$t('common.clientError'))
        }
        switch (this.user_type) {
            case 'system_user':
                this.systemLoginCheck = true
                this.cdShowWarehouse = true
                // this.getCDClientList()
                // this.getCDWarehouseList()
                break

            case 'client_user':
                this.$alert(this.$t('common.unauthorisedError'))
                break

            case 'warehouse_user':
                this.finalObject.warehouseId = userdetail.warehouseid
                this.cdWarehouse = this.finalObject.warehouseId
                this.showBoxInputs = true
                // this.getCDClientList()
                break

            default:
                this.$alert(this.$t('common.unauthorisedError'))
                break
        }
    },

    methods: {
        dateFormatDetail(date) {
            if (!date) return ''
            return moment(date).format('DD-MM-YY HH:mm:ss');
        },
        async getPackingBoxFlag(){
            let inputPayload = {
                clientid: localStorage.getItem("selectedClient") ? Number(localStorage.getItem("selectedClient")) : Number(localStorage.getItem("selectedClient")),
            }
            let response = await packingApis.getpackingboxflag(inputPayload, this.token)
            if (response.data.data.ErrorCode == 0) {
                if(response.data.data.data[0].value ==='yes'){
                    this.issuggestionEnabled = true
                    //  this.getSuggestedPackingDetail()
                 }else{
                    // showSplitBoxPacking && showBoxSuggestionSplit
                    this.issuggestionEnabled = false
                    this.showBoxSuggestionSplit = true;
                    // this.finalObject.issplited =true;
                    if(this.finalObject.issplited){
                        this.showSplitBoxPacking = true
                    }
                 }
            }
        },
        async getPackingBox(){
            let inputPayload = {
            clientid:localStorage.getItem("selectedClient"),
             warehouseid: localStorage.getItem("selectedWarehouse"),
             salesChannel: this.finalObject.salesChannel
            }
                let response = await packingApis.getPackingBox(inputPayload, this.token)
                if (response.data.errorcode == 0) {
                    this.listPackingBoxData = response.data.data;
                }
        },
        
        async SaveBoxSugestion(multiSplit = false){
            try {
                let reason = '';
                if(this.sugestboxid){
                    if(this.sugestboxid != this.packingboxid){
            if(this.overidereason == ''){
                            this.$alert(this.$t('boxList.selectOverideReason'))
                            return false
                        }
                        if(this.overidereason == 'Other'){
                            if(this.otherreason == ''){
                                this.$alert(this.$t('boxList.addOverideReason'))
                                return false
              }
                     }
                 }
                }
                if(this.otherreason != ''){
                    reason = this.otherreason;
                }else{
                    reason = this.overidereason;
                }
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid:localStorage.getItem("selectedClient"),
                    packingboxid:this.sugestboxid,
                  suggestedpackingbox:this.packingboxid,
                    orderid:this.finalObject.orderId,
                    boxchangereason:reason,
                    useremail:this.finalObject.userEmail,
                    initiateInvoiceLabelcall: this.initiatecall
                }
                this.isLoadingFeild = true
                let response = await packingApis.SaveBoxSugestion(inputPayload, this.token)
                if (response.data.ErrorCode == 0) {
                    this.$alertify.success(response.data.msg)
                    this.getSuggestedPackingDetail()
                    if(!multiSplit){
                        this.getBoxDetails(this.initiatecall)
                        this.addmodalShow = false
                        this.packingbox1 = true;
                    }
                    this.isSuggestionPresent = true
                    this.showSplitBoxPacking =true
                    this.isLoadingFeild = false
                }else{
                    this.$alertify.error(response.data.msg)
                }

            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }

        },

        async getWeight() {
            try {
                this.isLoading = true
                let weightResponse = await packingApis.getWeight(this.token)
                this.isLoading = false
                if (weightResponse.status == 200 && weightResponse.data.weight) {
                    this.finalObject.boxWeight = parseFloat(weightResponse.data.weight)
                } else {
                    this.$alert(this.$t('common.weighingMachineError'))
                    this.finalObject.boxWeight = 0
                }
            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
        },
        async getBoxDetails(intiateCall = 1) {
            try {
                if (this.finalObject.boxId < 1) {
                    return false
                }
                this.cleanForm()
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    invoiceLabelcall:intiateCall
                }
                let boxId = this.finalObject.boxId
                this.isLoading = true
                let response = await packingApis.getBoxDetails(inputPayload, this.token)
                let data = response.data.data.data
                this.packedbox = false;
                this.packingbox1 = true;
                this.packingbox =false;
                if (response.data.data.ErrorCode == 0) {
                    this.showPackingCompleteButton = true
                    document.getElementById('boxid').disabled = true
                    this.finalObject.merchantName = data.merchantName
                    this.finalObject.clientName = data.clientName
                    this.finalObject.orderId = data.orderId
                    this.finalObject.btoborder = data.btoborder
                    this.finalObject.salesChannel = data.salesChannel
                    this.finalObject.totalSkus = data.totalSkus
                    this.finalObject.totalQty = data.totalQty
                    this.finalObject.totalOrderQty = data.totalOrderQty
                    this.finalObject.cancelQty = data.cancelQty
                    this.finalObject.qtyQcAccept = data.qtyQcAccept
                    this.finalObject.qtyQcReject = data.qtyQcReject
                    this.finalObject.pickqty = data.pickqty
                    this.finalObject.orderShiByDate = data.orderShiByDate
                    this.finalObject.shipmentId = data.shipmentId
                    this.finalObject.boxStatus = data.boxStatus
                    this.finalObject.orderStatus = data.orderStatus
                    this.finalObject.orderSelfshipped = data.orderSelfshipped
                    this.finalObject.clientId = data.clientId
                    this.finalObject.sellerName = data.sellerName
                    this.finalObject.issplited = data.issplited
                    this.finalObject.isdestinationBox = data.isdestinationBox
                    this.finalObject.b2b_qc_done = data.b2b_qc_done
                    this.finalObject.invoicetriggered = data.invoicetriggered
                    this.finalObject.unicommerceOrderDetails = data.unicommerceOrderDetails
                    this.getPackingBoxFlag();
                    await this.splitShipmentEnableOrDisable();
                    this.initiatecall = (this.splitShimentEnable && !this.issingleQty) ? 0 : 1

                    if (Number(this.finalObject.cancelQty) > 0) {
                        this.finalObject.cancelProductDetails = data.cancelProductDetails
                    }
                    if(this.finalObject.issplited){
                        this.showBoxSuggestionSplit = true
                    }else{
                        this.showBoxSuggestionSplit = false
                    }
                    this.css2 = true
                    this.css1 = false
                    this.showBoxDetails = true
                    this.finalObject.salesChannelList = data.salesChannelList
                    this.salesChannelList = data.salesChannelList
                    this.options = data.rejectQCReasons
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0 && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == null || this.finalObject.btoborder == '')) {
                        this.showQCAndPackingSection = false
                    } else {
                        this.showQCAndPackingSection = true
                    }
                    if (((Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == '' || this.finalObject.btoborder == null)) || (this.finalObject.issplited || this.finalObject.isdestinationBox)) {
                        this.allowPackingComplete = true
                    }
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) < Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty))){                     
                        this.allowPackingComplete = false

                    }else{
                        this.allowPackingComplete = true
                    }
                        if ((Number(this.finalObject.pickqty) == Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject)) && this.finalObject.btoborder == 1) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                    }
                    if (this.finalObject.b2b_qc_done == 2 && this.finalObject.btoborder == 1) {
                        this.allowPackingComplete = false
                        this.showPackingCompleteButton = false
                    }

                   
                    this.finalObject.normalOrder = data.normalOrder
                    this.finalObject.isNimbus = data.isNimbus
                    this.finalObject.isRubicon = data.isRubicon
                    this.finalObject.isWmall = data.isWmall
                    this.finalObject.isUnicommerce = data.isUnicommerce
                    this.finalObject.isMultiseller = data.isMultiseller
                    this.finalObject.isincreff = data.isIncreff
                    this.finalObject.xbEcomFlag = data.xbEcomFlag
                    this.finalObject.xbEcomAwbNo = data.xbEcomAwbNo
                    this.finalObject.xbEcomCourierCompany = data.xbEcomCourierCompany
                    this.finalObject.showLabelButton = data.showLabelButton
                    this.finalObject.showInvoiceButton = data.showInvoiceButton
                    this.finalObject.shippingCourierCompany = null;
                    this.finalObject.shippingProviderFinal = null
                    if (this.finalObject.xbEcomFlag) {
                        this.finalObject.courierName = this.finalObject.xbEcomCourierCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.xbEcomCourierCompany,
                            'couriername': this.finalObject.xbEcomCourierCompany
                        })
                        this.finalObject.awbNo = this.finalObject.xbEcomAwbNo
                        this.showInvoiceAndLabels = false
                        if (this.finalObject.isRubicon) {
                            this.finalObject.orderTypeInput = 'isRubicon'
                            this.finalObject.orderType = 'Rubicon'
                        } else if (this.finalObject.isWmall) {
                            this.finalObject.orderTypeInput = 'isWmall'
                            this.finalObject.orderType = 'Wmall'
                        } else if (this.finalObject.isMultiseller) {
                            this.finalObject.orderTypeInput = 'isMultiseller'
                            this.finalObject.orderType = 'Flipkart'
                        } else if (this.finalObject.isUnicommerce) {
                            this.finalObject.orderTypeInput = 'isUnicommerce'
                            this.finalObject.orderType = 'Unicommerce'
                        } else {
                            this.finalObject.orderTypeInput = 'isNormal'
                            this.finalObject.orderType = 'CSV'
                        }
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                        if(data.showLabelButton==true || data.showInvoiceButton==true)
                        {
                            this.showInvoiceAndLabels = true
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                        })
                    } else if (this.finalObject.isRubicon) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.orderTypeInput = 'isRubicon'
                        this.finalObject.orderType = 'Rubicon'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        if (this.finalObject.courierName != 'Amazon') {
                            document.getElementById('awbno').disabled = true
                        } else {
                            this.finalObject.awbNo = ''
                        }
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isWmall) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.orderTypeInput = 'isWmall'
                        this.finalObject.orderType = 'Wmall'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isMultiseller) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isMultiseller'
                        this.finalObject.orderType = 'Flipkart'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isUnicommerce) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.shippingCourierCompany = data.shippingCourierCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.shippingCourierCompany,
                                'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
                            });
                            this.finalObject.shippingProviderFinal = this.finalObject.courierName;
                            this.finalObject.courierName = this.finalObject.shippingCourierCompany;
                        } else {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.shippingCode = data.shippingCode
                        this.finalObject.orderTypeInput = 'isUnicommerce'
                        this.finalObject.orderType = 'Unicommerce'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                            document.getElementById('awbno').disabled = true;
                            document.getElementById('couriername').disabled = true;
                          });
                    } else if (this.finalObject.isNimbus) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isNimbus'
                        this.finalObject.orderType = 'Nimbus'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.normalOrder) {
                        this.finalObject.orderTypeInput = 'isNormal'
                        this.showInvoiceAndLabels = false
                        this.finalObject.orderType = 'CSV'
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                        //alert(this.showInvoiceAndLabels)
                    }
                    else if (!this.finalObject.normalOrder && !this.finalObject.isUnicommerce) {
                        this.finalObject.orderTypeInput = 'isNormal'
                        this.showInvoiceAndLabels = false
                        this.finalObject.orderType = 'CSV'
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                        if(data.showLabelButton==true || data.showInvoiceButton==true)
                        {
                            this.showInvoiceAndLabels = true
                        }
                        //alert(this.showInvoiceAndLabels)
                    } else if (this.finalObject.isincreff) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCourierCompany
                        this.finalObject.shippingCourierCompany = data.shippingCourierCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.shippingCourierCompany,
                                'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
                            });
                            this.finalObject.shippingProviderFinal = this.finalObject.courierName;
                            this.finalObject.courierName = this.finalObject.shippingCourierCompany;
                        } else {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isIncreff'
                        this.finalObject.orderType = 'Increff'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        Vue.nextTick(() => {
                            document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                        })

                    }
                } else {
                    this.showPackingCompleteButton = false
                    this.showQCAndPackingSection = false
                    this.finalObject.unicommerceOrderDetails = data.unicommerceOrderDetails
                    if (data.isBoxValid) {
                        this.showInvoiceAndLabels = true
                        if(data.nimbusInvoiceAndLabel!=null || data.nimbusInvoiceAndLabel!='')
                        {
                            this.finalObject.shippingLabel = data.nimbusInvoiceAndLabel
                        }
                        if(data.nimbusinvoiceurl!=null || data.nimbusinvoiceurl!='')
                        {
                            this.finalObject.invoiceLabel = data.nimbusinvoiceurl
                        }
                        // alert("2")
                        document.getElementById('boxid').disabled = true
                        this.allowPackingComplete = true
                        this.finalObject.salesChannelList.push({
                            'courierid': data.shippingCompany,
                            'couriername': data.shippingCompany
                        })
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.shipmentStatus = data.shipmentStatus
                        this.finalObject.merchantName = data.merchantName
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.clientName = data.clientName
                        this.finalObject.orderId = data.orderId
                        this.finalObject.btoborder = data.btoborder
                        this.finalObject.salesChannel = data.salesChannel
                        this.finalObject.totalQty = data.totalQty
                        this.finalObject.cancelQty = data.cancelQty
                        if (Number(this.finalObject.cancelQty) > 0) {
                            this.finalObject.cancelProductDetails = data.cancelProductDetails
                        }
                        this.finalObject.totalOrderQty = data.totalOrderQty
                        this.finalObject.orderShiByDate = data.orderShiByDate
                        this.finalObject.shipmentId = data.shipmentId
                        this.finalObject.boxStatus = data.boxStatus
                        this.finalObject.orderStatus = data.orderStatus
                        this.finalObject.orderSelfshipped = data.orderSelfshipped
                        this.finalObject.clientId = data.clientId
                        this.css2 = true
                        this.css1 = false
                        this.showBoxDetails = true
                        this.finalObject.sellerName = data.sellerName
                        this.finalObject.normalOrder = data.normalOrder
                        this.finalObject.isNimbus = data.isNimbus
                        this.finalObject.xbEcomFlag = data.xbEcomFlag
                        this.finalObject.isRubicon = data.isRubicon
                        this.finalObject.isWmall = data.isWmall
                        this.finalObject.isUnicommerce = data.isUnicommerce
                        this.finalObject.isMultiseller = data.isMultiseller
                        this.finalObject.showLabelButton = data.showLabelButton
                        this.finalObject.showInvoiceButton = data.showInvoiceButton
                            this.getPackingBoxFlag();
                            await this.splitShipmentEnableOrDisable();
                  
                        this.initiatecall = (this.splitShimentEnable && !this.issingleQty) ? 0 : 1   
                        if (this.finalObject.isRubicon) {
                            this.finalObject.orderTypeInput = 'isRubicon'
                            this.finalObject.orderType = 'Rubicon'
                        } else if (this.finalObject.isWmall) {
                            this.finalObject.orderTypeInput = 'isWmall'
                            this.finalObject.orderType = 'Wmall'
                        } else if (this.finalObject.isMultiseller) {
                            this.finalObject.orderTypeInput = 'isMultiseller'
                            this.finalObject.orderType = 'Flipkart'
                        } else if (this.finalObject.isUnicommerce) {
                            this.finalObject.orderTypeInput = 'isUnicommerce'
                            this.finalObject.orderType = 'Unicommerce'
                        } else if (this.finalObject.isNimbus) {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.finalObject.orderTypeInput = 'isNimbus'
                            this.finalObject.orderType = 'Nimbus'
                        } else if (this.finalObject.normalOrder) {
                            this.finalObject.orderTypeInput = 'isNormal'
                            this.finalObject.orderType = 'CSV'
                        } else if (this.finalObject.isincreff) {
                            this.finalObject.orderTypeInput = 'isIncreff'
                            this.finalObject.orderType = 'Increff'
                        }


                    } else {
                        this.showInvoiceAndLabels = false
                        document.getElementById('boxid').value = null
                        this.finalObject.boxId = ""
                    }
                    //if (this.finalObject.b2b_qc_done == 2  && this.finalObject.btoborder == 1 ) {
                    //      this.showPackingCompleteButton = false
                    //}
                    if ((this.finalObject.orderStatus == 'packed' ||this.finalObject.orderStatus == 'sr' || this.finalObject.orderStatus == 'rto')&& this.finalObject.btoborder == 1 && this.finalObject.btoborder != '') {
                        this.showPackdata = true
                    }
                    if((this.finalObject.orderStatus == 'packed' ||this.finalObject.orderStatus == 'sr' || this.finalObject.orderStatus == 'rto') && this.finalObject.btoborder == 0 ){
                         this.hideCourierAwbDetails= true
                         this.splitShimentEnable = false 
                         this.issingleQty = false
                         this.allowPackingComplete= false
                         this.hidesplitBoxbtn=true
                         this.hideproceedWithOutSplit = true
                         
                     }
                    this.$alert(response.data.data.msg, boxId)
                }
                if (this.splitShimentEnable && this.finalObject.orderType !== 'CSV') {
                    this.finalObject.showLabelButton = false;
                    this.finalObject.showInvoiceButton = false;
                    this.showInvoiceAndLabels = false;
                    this.hideInvoiceLabel = true;
                    this.hideCourierAwbDetails = true;
                    
                    if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) > 1) {
                      this.issingleQty = false;
                    } else {
                      this.issingleQty = true;
                    }
                    
                    this.showButtonManualPacking = false;
                  }
                  
                  if (this.finalObject.issplited || this.finalObject.isdestinationBox) {
                    this.showPackingCompleteButton = true;
                    this.showQCAndPackingSection = true;
                    // this.packingbox1 = false;
                    // this.allowPackingComplete = false
                }
                const validStatuses = ['packed', 'sr', 'rto', 'cancelled'];
                if (((validStatuses.includes(this.finalObject.orderStatus) &&  this.finalObject.boxStatus === 'in_shipping')) || (this.finalObject.boxStatus === 'cancelled' || this.finalObject.orderStatus === 'cancelled')) {                   
                    this.showPackingCompleteButton = false;
                    this.showQCAndPackingSection = false;
                    this.issuggestionEnabled = false
                }
                  if(!this.showPackingCompleteButton && !this.showQCAndPackingSection ){
                    this.issingleQty = true
                  }
                  if (this.splitShimentEnable  && this.finalObject.invoicetriggered && this.finalObject.orderType !== 'CSV' && ((this.finalObject.shippingLabel || this.finalObject.invoiceLabel) || (data.showLabelButton || data.showInvoiceButton))) {
                    this.showInvoiceAndLabels = true;
                    this.finalObject.showInvoiceButton = true;
                    this.finalObject.showLabelButton = true;
                    this.issingleQty = true;
                    this.hideproceedWithOutSplit = true;
                    this.hideCourierAwbDetails = false;
                    this.hidesplitBoxbtn = true;
                  }
                  if (this.finalObject.orderType !== 'CSV' && (!this.finalObject.shippingLabel || !this.finalObject.invoiceLabel) && this.finalObject.unicommerceOrderDetails &&
                  !this.finalObject.unicommerceOrderDetails.status) {
                    this.invoiceFailureReason = this.finalObject.unicommerceOrderDetails.msg
                    this.$alert("UnicommerceDetails error : "+this.invoiceFailureReason)
                }
                  if (this.finalObject.issplited && this.finalObject.invoicetriggered) {
                    this.hidesplitBoxbtn = false;
                    this.hideCourierAwbDetails = true;
                  }       
                  // below commented code was added if awbNo or courierName not fetching for first call but this doesnt work since
                  //uniware take some time to process it and does not return data by again calling getboxdetails..

                //   if((!this.finalObject.awbNo || !this.finalObject.courierName) && this.finalObject.isunicommerce && (intiateCall == 1 || this.finalObject.totalQty == 1) && this.counterFornullvalue < 1 && this.finalObject.isdestinationBox && this.splitShimentEnable){
                //     this.getBoxDetails(1)
                //     this.counterFornullvalue = 1
                //    }
                  if (intiateCall === 2) {
                    this.showSplitBoxData = true;
                    this.showSplitButton = false;
                  }

                this.isLoading = false

            } catch (err) {
                console.log(err)
                this.isLoading = false
            }   
        },
        productQC(obj) {
            if (obj == "reject") {
                this.isProductReject = true
            } else {
                this.updateQcDetails(obj)
            }
        },
        async updateQcDetails(obj) {
            try {
                if (obj == 'reject' && this.finalObject.rejectReasons.length < 1) {
                    this.$alert(this.$t('boxList.rejectReasonError'))
                    return false
                }
                if (this.finalObject.showQtyInput && Number(this.finalObject.qcQtyPending) != Number(this.finalObject.productQty)) {
                    if (Number(this.finalObject.qcQtyPending) > Number(this.finalObject.productQty)) {
                        this.$alert(this.$t('boxList.pickedQtyLessError'))
                    } else {
                        this.$alert(this.$t('boxList.pickedQtyGreaterError'))
                    }
                    return false
                }
                //  alert(this.finalOpbject.warehouseId)
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid: localStorage.getItem("selectedClient"),
                    orderid: this.finalObject.orderId,
                    productid: this.finalObject.productId.trim(),
                    qcstatus: obj,
                    rejectreasons: obj == "reject" ? this.finalObject.rejectReasons : [],
                    useremail: this.finalObject.userEmail,
                    productqty: this.finalObject.showQtyInput ? this.finalObject.productQty : '',
                    btoborder: this.finalObject.btoborder,
                }
                this.isLoadingFeild = true
                let response = await packingApis.updateQcDetails(inputPayload, this.token)
                let data = response.data.data.data
                if (response.data.data.ErrorCode == 0) {
                    this.finalObject.rejectReasons = []
                    this.rejectReasons = []
                    this.finalObject.productId = ''
                    this.finalObject.productQty = ''
                    this.finalObject.showQtyInput = false
                    this.finalObject.qcQtyPending = ''
                    this.finalObject.scanproductData = {}
                    this.finalObject.qtyQcAccept = data.totalQCAcceptQty
                    this.finalObject.qtyQcReject = data.totalQCRejectQty
                    this.isProductReject = false
                    this.showProductQcDetails = false
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
                        this.showQCAndPackingSection = false
                    } else {
                        this.showQCAndPackingSection = true
                    }
                    if ((Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == null || this.finalObject.btoborder == '')) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                        if (this.finalObject.isRubicon || this.finalObject.isWmall || this.finalObject.isMultiseller || this.finalObject.isUnicommerce) {
                            document.getElementById('awbno').disabled = true
                            if (this.finalObject.courierName == 'Amazon' && this.finalObject.isRubicon) {
                                document.getElementById('awbno').disabled = false
                                this.finalObject.awbNo = ''
                            }
                            document.getElementById('couriername').disabled = true
                        }
                    }
                    if ((Number(this.finalObject.pickqty) == Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject)) && this.btoborder == 1) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                    }

                    this.$alertify.success(response.data.data.msg)
                    document.getElementById('productid').disabled = false
                    this.getBoxDetails(this.initiatecall);

                } else {
                    this.$alert(response.data.data.msg, this.finalObject.productId.trim())
                    document.getElementById('productid').disabled = false
                    return false
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },
     //Cross DOck
        // getCDClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.cdClientList = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			'warehouseid': this.cdWarehouse,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.cdClientList = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
        // getCDWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.cdWarehouseList = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			'clientid': this.cdClient ,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.cdWarehouseList = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
        // clientSelected() {
        //     if(this.user_type == 'system_user')
		// 	{
        //         this.cdWarehouse = '';
        //         }
        //     this.getCDWarehouseList();
		// },
        validateProductCrossDock() {
            if(localStorage.getItem("selectedClient") == 'undefined'){
                this.$alertify.error(this.$t('common.clientError'));
                return false;
            }
            else if(localStorage.getItem("selectedWarehouse") == 'undefined')
            {
                this.$alertify.error(this.$t('common.warehouseError'));
                return false;
            }
            else if(this.cdEanCode == '')
            {
                this.$alertify.error(this.$t('common.eanCodePHolder'));
                return false;
            }
           
            this.cdFieldsDisabled = true;
            this.cdLoader = true;
            var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					'clientid':localStorage.getItem("selectedClient"),
                    'warehouseid' : localStorage.getItem("selectedWarehouse"),
                    'productid' : this.cdEanCode,
                    'useremail' : this.finalObject.userEmail
				});
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'validateProductCrossDoc',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then( async result => {
                if(result.data.data.status){
                    this.cdLoader = false;
                    this.cdDetails = true;
                    this.cdValidateProductResult = result.data.data.data;
                    this.cdPackingDetails = true;
                    this.cdPackingDetails = true;
                    this.getCrossDockBoxRecommendation();
                    this.cdPackingDetails = true;
                    this.getCrossDockBoxRecommendation();
                    this.getCrossDockPackingBoxType();
                    this.getCrossDockBoxRecommendation();
                    this.getPackingBoxFlag();
                    if(this.issuggestionEnabled == false) {this.cdOutQcDetails = true;}
                    //getting product details
                    let inputPayload = {
                        warehouseid: localStorage.getItem("selectedWarehouse"),
                        boxid: this.cdValidateProductResult.boxId,
                        clientid: localStorage.getItem("selectedClient"),
                        orderid: this.cdValidateProductResult.orderId,
                        productid: this.cdEanCode.trim()
                    }
                    this.isLoadingFeild = true
                    this.cdResponseProductDetails = await (await packingApis.scanProductPacking(inputPayload, this.token, 0)).data.data.data;
                    //visibility of QC Section based on accepted and rejected quantity
                    if ((Number(this.cdValidateProductResult.qtyQcAccept) + Number(this.cdValidateProductResult.qtyQcReject) >= Number(this.cdValidateProductResult.totalQty) - Number(this.cdValidateProductResult.cancelQty)) && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == null || this.finalObject.btoborder == '')) {
                        this.cdOutQcDetails = false;
                        this.cdQcDone = true;
                        //if config is disabled and qc is done show shipping details
                        if(!this.cdPackingDetails || !this.issuggestionEnabled){
                            this.cdShippingDetails = true;
                        }
                    } else {
                        this.cdOutQcDetails = true
                    }
                }
                else {
                    if(result.data.errorLabel){
                        this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`))
                    }else{
                        this.$alertify.error(this.$t('apiErrors.NO_DATA_CROSS_DOCK'))
                    }
                    this.cdLoader = false;
                    this.onCrossDockReset();
                }
            }, error => {
                console.error(error)
                this.cdLoader = false;
            })
        },
        async getCrossDockBoxRecommendation(){
            let inputPayload = ({
                warehouseid: localStorage.getItem("selectedWarehouse"),
                boxid: this.cdValidateProductResult.boxId.toString(),
                clientid: localStorage.getItem("selectedClient")
               });
               let response = await packingApis.getPackingSuggestBox(inputPayload, this.token);
               if(response.status && response.data.data){
                this.cdPackingDetRecommBoxType = response.data.data[0];
                this.cdPackingDetSelectedBoxType = await this.cdPackingDetConfirmBoxType.find(item => item.boxname === this.cdPackingDetRecommBoxType.name);
               }
        },
        async getCrossDockPackingBoxType(){
            let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    clientid: localStorage.getItem("selectedClient"),
                    salesChannel: this.cdValidateProductResult.salesChannel
                }
                    let response = await packingApis.getPackingBox(inputPayload, this.token)
                    this.cdPackingDetConfirmBoxType = response.data.data;
        },
        async crossDockBoxSelected(){
            this.cdShowOtherReasonField = false;
            this.cdPackingDetReason = '';
            if(this.cdPackingDetSelectedBoxType != '' && this.cdPackingDetRecommBoxType.name != this.cdPackingDetSelectedBoxType.boxname){
                this.cdBoxDifferentThanReccomendation = true;
                this.cdShowDiffPackBoxReason = true;
            }
            else{
                this.cdBoxDifferentThanReccomendation = false;
                this.cdShowDiffPackBoxReason = false;
            } 
        },
        async crossDockQC(obj){
            this.cdOutQcDetails = false;
            if( this.cdPackingDetails==false || (this.cdPackingDetails==true && this.issuggestionEnabled==false)) //edit for the bug make this true only when config is enabled
            {
                this.cdShippingDetails = true;
            }
            let inputPayload = {
                warehouseid: localStorage.getItem("selectedWarehouse"),
                boxid: this.cdValidateProductResult.boxId,
                clientid: localStorage.getItem("selectedClient"),
                orderid: this.cdValidateProductResult.orderId,
                productid: this.cdEanCode.trim(),
                qcstatus: obj,
                rejectreasons: obj == "reject" ? [] : [], //update null with rejectreason
                useremail: this.finalObject.userEmail,
                productqty: 1,
                btoborder: null,
            }
            this.cdLoader = true;
            let response = await packingApis.updateQcDetails(inputPayload, this.token);
            if(response.data.data.status && response.data.data.data)
            {
            this.cdLoader = false;
            this.$alertify.success(this.$t('apiErrors.PRODUCT_QC_DONE'));
            }
        },
        crossDockBoxChangeReason(){
            if(this.cdPackingDetReason == "Box not suitable"){
                this.cdPackingDetReason = 'Box not suitable';
                this.cdShowOtherReasonField = false;
            }
            if(this.cdPackingDetReason == "Other"){
                this.cdShowOtherReasonField = true;
                this.$nextTick(function () {
                    this.$refs.otherReasonInput.focus();
                })
                this.cdPackingDetReason = '';
            }
        },
        async captureCrossDockBoxWeight() {
            try {
                this.cdLoader = true;
                let weightResponse = await packingApis.getWeight(this.token)
                this.cdLoader = false;
                if (weightResponse.status == 200 && weightResponse.data.weight) {
                    this.cdPackingDetBoxWeight = parseFloat(weightResponse.data.weight)
                    this.$alertify.success(this.$t('boxList.boxWeightPlaceHolder') + ': ' + this.cdPackingDetBoxWeight + ' kg');
                } else {
                    this.$alertify.error(this.$t('common.weighingMachineError'))
                    this.cdPackingDetBoxWeight = 0
                }
            } catch (err) {
                this.$alertify.error(this.$t('crossDockPacking.unableCaptureWeight'));
                console.log(err)
                this.cdLoader = false
            }
        },
        async crossDockSaveBoxSugestion() {
            if((this.cdBoxDifferentThanReccomendation) && (this.cdPackingDetReason == '' || this.cdPackingDetReason == null)){
                this.$alert(this.$t('common.enterReasonPlaceHolder'))
            }
            else{
                this.cdShowOtherReasonField = false;
                try {
                    let suggestedPackBoxId = await this.cdPackingDetConfirmBoxType.find(item => item.boxname === this.cdPackingDetRecommBoxType.name)
                  let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.cdValidateProductResult.boxId,
                    clientid: localStorage.getItem("selectedClient"),
                    packingboxid: this.cdPackingDetSelectedBoxType.boxid,
                    suggestedpackingbox: suggestedPackBoxId.boxid,
                    orderid: this.cdValidateProductResult.orderId,
                    boxchangereason: this.cdPackingDetReason,
                    useremail: this.finalObject.userEmail,
                    initiateInvoiceLabelcall: 1,
                  };
                  this.cdLoader = true;
                  let response = await packingApis.SaveBoxSugestion(inputPayload, this.token);
                  if (response.data.ErrorCode == 0) {
                    this.$alertify.success(this.$t('apiErrors.PACKING_BOX_SAVE_SUCESSFULLY'));
                    this.cdLoader = false;
                    this.cdPackingDetails = false;
                    if( this.cdOutQcDetails== false && this.cdPackingDetails==false)
                    {
                        this.cdShippingDetails = true;
                    }
                  } else {
                    this.$alertify.error(response.data.msg); 
                  }
                } catch (err) {
                  console.log(err);
                }
            }
          },
          printCrossDockInvoice(){
            let data = this.cdValidateProductResult.invoiceUrl;
            var newWindow = window.open();
            newWindow.document.write('<iframe src="data:application/pdf;base64,' + (data) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
            newWindow.document.title = "Invoice-" + this.cdValidateProductResult.orderId;
          },
          crossDockOtherCourierCompany(){
            if (this.cdCourierName === 'Others'){
                this.cdshowOtherCourierNameField = true;
                this.cdCourierName = '';
                this.$nextTick(function () {
                    this.$refs.otherCourierCompanyInput.focus();
                })
            }
          },
          async completeCrossDockPacking() {
            if (this.cdCourierName == '') {
			    this.couriercompanyerr = this.$t('courierMapping.transportererr');
			}
            if (this.cdAwbNo == '') {
			    this.awbNoerr = this.$t('packingb2b.b2bPacking.modal.awbNoError');
			}
            try {
                this.cdLoader = true
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.cdValidateProductResult.orderId,
                    awbno: this.cdAwbNo,
                    shippingcompany: this.cdCourierName,
                    boxid: this.cdValidateProductResult.boxId.toString(),
                    useremail: this.finalObject.userEmail,
                    userid: this.finalObject.userId,
                    boxweight: this.cdPackingDetBoxWeight,
                    shippinglabel: this.cdValidateProductResult.labelUrl,
                    invoicelabel: this.cdValidateProductResult.invoiceUrl,
                    shippingcode: this.cdValidateProductResult.shippingCode,
                    ordertype: this.finalObject.orderTypeInput,//
                    saleschannel: this.cdCourierName,
                    xbecomflag: this.cdValidateProductResult.xbEcomFlag,
                    shippingprovider: ''
                }
                let resultCompleteBoxPacking = await packingApis.completeBoxPacking(inputPayload, this.token);
                if (resultCompleteBoxPacking.status) {
                    this.$alertify.success(this.$t('apiErrors.Order_Ready_Ship'));
                    this.$alertify.alert(this.$t('common.packingCompleted') , this.$t('common.awbNo') + ": " +  resultCompleteBoxPacking.data.data.data.awbno + "<br/>" +  this.$t('orders.shippingId') + ": " + resultCompleteBoxPacking.data.data.data.shippingid);
                    
                } else {
                    this.$alert(resultCompleteBoxPacking.data.data.msg, this.finalObject.boxId)
                }
                this.cdLoader = false;
                this.onCrossDockReset();
            } catch (err) {
                console.log(err);
                this.cdLoader = false;
            }
        },
        onCrossDockReset(){
            this.cdshowOtherCourierNameField = false;
            this.cdFieldsDisabled = false
            this.cdShowOtherReasonField = false
            this.cdBoxDifferentThanReccomendation = false
            this.cdLoader = false
            this.cdDetails = false
            this.cdPackingDetails = false
            this.cdOutQcDetails = false
            this.cdQcDone = false
            this.cdValidateProductResult = ''
            this.cdClient = ''
            this.cdEanCode = ''
            if(this.user_type == 'system_user'){
                this.cdWarehouse = ''
            }
            this.cdResponseProductDetails = ''
            this.cdOrderID = ''
            this.cdOrderType = ''
            this.cdShipByDate = ''
            this.cdOrderQuantity = ''
            this.cdSalesChannel = ''
            this.cdOutQcdetName = ''
            this.cdOutQcdetColor = ''
            this.cdPackingDetRecommBoxType = ''
            this.cdPackingDetConfirmBoxType = ''
            this.cdPackingDetSelectedBoxType = ''
            this.cdShowDiffPackBoxReason = false
            this.cdPackingDetReason = ''
            this.cdPackingDetBoxWeight = 0
            this.cdCourierName = ''
            this.cdAwbNo = ''
            this.cdShippingDetails = false
            this.issuggestionEnabled = false
            this.couriercompanyerr = ''
            this.awbNoerr = ''
            document.getElementById('cdField').value = ''
            document.getElementById('cdboxweight').value = 0
            document.getElementById('cdawbfield').value = ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/packingb2c/packingCrossDock.component.js